import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.CompareWorkspaceCustomPanel,
  title: 'Custom Panel',
  category: ComponentCategory.General,
  droppable: true,
  // Only meaningful as a child of CompareWorkspace — added via its "add
  // panel" affordance, not dragged in from the general component palette.
  showInLibrary: false,
};
